import { ReactNode } from 'react';
import { MarketButton } from '@market/react';

// When href is set MarketButton renders as an anchor, so a CTA can be either a
// JS action (Add to cart) or a link (Contact sales) without a separate component.
interface PrimaryProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  href?: string;
}

const Primary = ({
  children,
  className = '',
  onClick,
  disabled = false,
  href,
}: PrimaryProps) => {
  return (
    <MarketButton
      rank="primary"
      className={className}
      onClick={onClick}
      data-testid="cta-subnav-primary"
      disabled={disabled}
      href={href}
    >
      {children}
    </MarketButton>
  );
};

export default Primary;
